export default __webpack_public_path__ + "static/hero-homepage-416a60bfe102bfff1d9f5ca0cf5924c4.jpg";